import { BASE_URLS, ENVIRONMENT_MODE } from "../../../../config/constants";
import { AxiosResponse } from "axios";
import axios from "../../../../config/axiosInterceptor";
import { RcFile } from "antd/es/upload";
import { BulkUploadType, CreateCrewYardType } from "./types";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const uploadUserImage = async ({
  owner_id,
  image,
  image_type,
}: {
  owner_id: string;
  image: RcFile | File;
  image_type: string;
}): Promise<AxiosResponse<void>> => {
  const formData = new FormData();
  formData.append("owner_id", owner_id);
  formData.append("image", image);
  formData.append("image_type", image_type);
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return axios.post(`${baseURL}uploadUserImage`, formData, config);
};

export const createCrewYard = (
  payload: CreateCrewYardType
): Promise<AxiosResponse<CreateCrewYardType>> => {
  return axios.post(`${baseURL}createCrewYard`, payload);
};

export const updateCrewYardById = (
  id: string,
  payload: CreateCrewYardType
): Promise<AxiosResponse<CreateCrewYardType>> => {
  return axios.patch(`${baseURL}updateCrewYardById/${id}`, payload);
};

export const deleteCrewYard = (
  crewYardIds: string[] | React.Key[]
): Promise<AxiosResponse<string>> => {
  return axios.delete(`${baseURL}deleteCrewYard`, { data: crewYardIds });
};

export const crewYardBulkUpload = (
  payload: BulkUploadType[]
): Promise<AxiosResponse<BulkUploadType>> => {
  return axios.post(`${baseURL}crewYardBulkUpload`, payload);
};

export const crewYardBulkUploadCSV = async ({
  company_id,
  files,
}: {
  company_id: string;
  files: RcFile | File;
}): Promise<AxiosResponse<void>> => {
  const formData = new FormData();
  formData.append("company_id", company_id);
  formData.append("files", files);
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return axios.post(`${baseURL}crewYardBulkUploadCSV`, formData, config);
};
